module.exports = __webpack_public_path__ + "static/pictorial and textual logo-b9ca7ec551f94a901ab047e80d60fb6b.png";